export const maptiler_key = "fDn7onrAN6WCCfMGf1vL";
export const mapbox_token =
    "pk.eyJ1IjoibWF0aGVtYXRpeGFsIiwiYSI6ImNqdG4wMTZhbDQyNjg0M251c2QxNXVlMXUifQ.zfqe8eLtHoA-1bAywqMpng";
